import { useState, useEffect } from "react";
import {
  getImageHorizontalAligment,
  getImageLayout,
  isLayoutFullWidth,
} from "../utils";
import type { HorizontalAlignType, ImageLayoutType } from "../utils";

export const useGetImageStyles = (stylesArray: string[]) => {
  const [horizontalImageAlign, setHorizontalAlign] =
    useState<HorizontalAlignType | null>(null);
  const [imageLayout, setImageLayout] = useState<ImageLayoutType | null>(null);
  const [imageFullWidth, setImageFullWidth] = useState(false);

  useEffect(() => {
    const hAligns = getImageHorizontalAligment(stylesArray);
    const layouts = getImageLayout(stylesArray);
    const fWidth = isLayoutFullWidth(stylesArray);

    setHorizontalAlign(hAligns[0] ?? null);
    setImageLayout(layouts[0] ?? null);
    setImageFullWidth(fWidth);
  }, [stylesArray.join(" ")]);

  return {
    horizontalImageAlign,
    imageLayout,
    imageFullWidth,
  };
};
